import { render, staticRenderFns } from "./StoresFetcher.vue?vue&type=template&id=4daf580e"
import script from "./StoresFetcher.vue?vue&type=script&lang=js"
export * from "./StoresFetcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports